import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CompanyComponent } from '@login/pages/sign-up/company/company.component';
import { InviteComponent } from '@login/pages/sign-up/invite/invite.component';
import { SignupComponent } from '@login/pages/sign-up/signup/signup.component';
import { SelectPlanComponent } from './select-plan/select-plan.component';
import { RedeemComponent } from './redeem/redeem.component';
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';
import { ProfileCompletionComponent } from './profile-completion/profile-completion.component';
import { QuickSignupComponent } from './quick-signup/quick-signup.component';
import { ScanningConfigComponent } from './scanning-config/scanning-config.component';
import { SuccessComponent } from './success/success.component';
import { RegistrationFlowGuard } from '@core/guards/registration-flow.guard';
import { quickRegisterRedirectGuard } from '@core/guards/quick-register-redirect.guard';
import { CheckoutSuccessComponent } from '@dashboard/pages/company/checkout-success/checkout-success.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        // /register/quick is the one entry point (#943). The guard forwards
        // everyone there with the query string, except an invitee, who keeps
        // this form with the invited email locked.
        component: SignupComponent,
        canActivate: [quickRegisterRedirectGuard],
      },
      {
        path: 'profile-completion',
        component: ProfileCompletionComponent,
        canActivate: [RegistrationFlowGuard],
      },
      {
        path: 'quick',
        component: QuickSignupComponent,
      },
      {
        path: 'company-profile',
        component: CompanyComponent,
        canActivate: [RegistrationFlowGuard],
      },
      {
        path: 'company',
        component: CompanyComponent,
        canActivate: [RegistrationFlowGuard],
      },
      {
        path: 'scanning-config',
        component: ScanningConfigComponent,
        canActivate: [RegistrationFlowGuard],
      },
      {
        path: 'success',
        component: SuccessComponent,
        canActivate: [RegistrationFlowGuard],
      },
      {
        path: 'company-invite',
        component: InviteComponent,
      },
      {
        path: 'select-plan',
        component: SelectPlanComponent,
        canActivate: [RegistrationFlowGuard],
      },
      {
        path: 'redeem',
        component: RedeemComponent,
      },
      {
        path: 'checkout-success',
        component: CheckoutSuccessComponent,
      },
      {
        path: 'unsubscribe',
        component: UnsubscribeComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SignUpRoutingModule {}
